// ATELIER VALTIS — ajoute / retire automatiquement les cadeaux offerts (produits à 0 €) selon le contenu du panier. 21/10/2026
// Règles : 1 « couples constructeur » (variante Moto ou Voiture) + 1 kit d'adaptateurs par clé ou coffret ; 1 tableau des couples dès qu'il y a une clé ou un coffret ;
// 1 lot de 2 piles AA par clé électronique ; jeu de tournevis Torx offert dès 399 € (hors cadeaux). Les cadeaux seuls sont retirés.
// MAJ 26/10/2026 (2) : quantités par clé rétablies pour kit / piles / tableau, couples constructeur = 1 ligne (voir wanted()). Ancienne règle du 26/10 : chaque cadeau limité à 1 exemplaire (×1) ; sans clé ni coffret payant, toutes les lignes cadeaux sont retirées (Torx compris).
// Contrôle lancé au chargement de chaque page (dont /cart), à l'ouverture du tiroir et après chaque appel /cart/add, /cart/change, /cart/update, /cart/clear.
import { ThemeEvents } from '@theme/events';

const G = { cm: 55536593437015, cv: 55536593469783, tab: 55536596025687, kit: 55536596418903, pil: 55536596451671, tor: 55536596517207 };
const GIFT_IDS = Object.values(G);
const TIER_CENTS = 39900;
// Jeu de tournevis Torx vendu (59 €) : ne compte pas pour le palier de 399 €. Si le reste du panier atteint 399 €, 1 tournevis payé bascule en offert (validé par Tayou le 22/10/2026).
const PAID_TORX = 54007536353623;
// Kit adaptateurs vendu (19,90 €) : avec une clé ou un coffret, chaque kit payé bascule en kit offert (1 kit offert par clé), et revient payé si la clé est retirée (validé par Tayou le 22/10/2026).
const PAID_KIT = 55549109010775;
// Packs clés manuelles (24/10/2026) : nombre de clés moto (m) et voiture (v) dans chaque pack → 1 « couples constructeur » + 1 kit offerts par clé.
const PACKS = {
  'pack-cle-dynamometrique-manuelle-kit-carenage': { m: 1, v: 0 },
  'pack-cle-dynamometrique-manuelle-torx-moto': { m: 1, v: 0 },
  'pack-cle-dynamometrique-manuelle-duo-moto': { m: 1, v: 1 },
  'pack-cle-dynamometrique-manuelle-roues': { m: 0, v: 1 },
  'pack-cle-dynamometrique-manuelle-gros-serrages': { m: 0, v: 1 },
  'pack-coffret-cle-dynamometrique-moto-axe-de-roue': { m: 2, v: 0, kit: 0 },
};
function kswapGet() { try { return Number(sessionStorage.getItem('av-kswap')) || 0; } catch (e) { return 0; } }
function kswapSet(n) { try { if (n > 0) sessionStorage.setItem('av-kswap', String(n)); else sessionStorage.removeItem('av-kswap'); } catch (e) {} }
function swapGet() { try { return Number(sessionStorage.getItem('av-tswap')) || 0; } catch (e) { return 0; } }
function swapSet(n) { try { if (n > 0) sessionStorage.setItem('av-tswap', String(n)); else sessionStorage.removeItem('av-tswap'); } catch (e) {} }
const MOTO = [
  'cle-dynamometrique-electronique-1-4-10-nm', 'cle-dynamometrique-electronique-1-4-30-nm', 'cle-dynamometrique-electronique-3-8-60-nm',
  'cle-dynamometrique-manuelle-1-4-2-5-30-nm', 'cle-dynamometrique-manuelle-3-8-5-60-nm', 'coffret-cle-dynamometrique-moto',
];
let busy = false;
let again = false;

function kind(h) {
  if (h.includes('cle-dynamometrique-electronique')) return 'el';
  if (h.includes('cle-dynamometrique-manuelle')) return 'ma';
  if (h.startsWith('coffret-')) return 'cf';
  return 'x';
}

function wanted(cart) {
  // MAJ 26/10/2026 (2, demande de Tayou) : cadeaux physiques (kit, piles, tableau) = 1 par clé / coffret payant qui y donne droit ;
  // un pack compte pour le nombre de clés qu'il contient (table PACKS, comme sur sa fiche) ; « Vos couples constructeur » = 1 seule ligne
  // par commande, quantité 1 (variante Moto si les clés moto sont au moins aussi nombreuses que les clés voiture, sinon Voiture) ;
  // MAJ 26/10/2026 (3) : « Tableau des couples » = 1 seule ligne ×1 par commande, comme « Vos couples constructeur » ; kit et piles restent 1 par clé ;
  // jeu de tournevis Torx = 1 dès 399 € ; sans clé ni coffret payant, aucun cadeau.
  const d = {};
  const add = (id, q) => { if (q > 0) d[id] = (d[id] || 0) + q; };
  let tools = 0, nm = 0, nv = 0, el = 0, kit = 0, total = 0;
  for (const it of cart.items) {
    if (GIFT_IDS.includes(it.variant_id)) continue;
    if (it.variant_id === PAID_TORX) continue;
    total += it.final_line_price;
    const pk = PACKS[it.handle];
    if (pk) {
      tools += (pk.m + pk.v) * it.quantity;
      nm += pk.m * it.quantity;
      nv += pk.v * it.quantity;
      kit += ('kit' in pk ? pk.kit : pk.m + pk.v) * it.quantity;
      continue;
    }
    const k = kind(it.handle);
    if (k === 'x') continue;
    tools += it.quantity;
    if (k === 'el') el += it.quantity;
    if (MOTO.includes(it.handle)) nm += it.quantity; else nv += it.quantity;
    if (k !== 'cf') kit += it.quantity;
  }
  if (tools === 0) return {};
  add(nm > 0 && nm >= nv ? G.cm : G.cv, 1);
  add(G.tab, 1);
  add(G.kit, kit);
  add(G.pil, el);
  if (total >= TIER_CENTS) add(G.tor, 1);
  return d;
}

function setCount(items) {
  const count = document.querySelector('cart-icon [data-ref="cart-count"]');
  if (!count || !items) return;
  count.textContent = items.filter((i) => !GIFT_IDS.includes(i.variant_id)).reduce((s, i) => s + i.quantity, 0);
}

async function sync() {
  if (busy) { again = true; return; }
  busy = true;
  try {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    const want = wanted(cart);
    const have = {};
    for (const it of cart.items) if (GIFT_IDS.includes(it.variant_id)) have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity;
    const updates = {};
    let changed = false;
    for (const id of GIFT_IDS) {
      const w = want[id] || 0, h = have[id] || 0;
      if (w !== h) { updates[id] = w; changed = true; }
    }
    // Bascule tournevis payé -> offert (et retour en arrière si le palier n'est plus atteint)
    const paidT = cart.items.filter((i) => i.variant_id === PAID_TORX).reduce((a, i) => a + i.quantity, 0);
    const wantT = want[G.tor] || 0, haveT = have[G.tor] || 0;
    if (wantT > haveT && paidT > 0) { updates[PAID_TORX] = paidT - 1; changed = true; swapSet(swapGet() + 1); }
    else if (wantT < haveT && swapGet() > 0) { updates[PAID_TORX] = paidT + 1; changed = true; swapSet(swapGet() - 1); }
    // Bascule kit adaptateurs payé <-> offert
    const paidK = cart.items.filter((i) => i.variant_id === PAID_KIT).reduce((a, i) => a + i.quantity, 0);
    const sK = kswapGet(), origK = paidK + sK, tK = Math.min(origK, want[G.kit] || 0);
    if (tK !== sK) { updates[PAID_KIT] = origK - tK; changed = true; kswapSet(tK); }
    if (!changed) {
      setCount(cart.items);
      // Page /cart affichée avec un contenu périmé (panier modifié entre-temps) : un seul rechargement.
      if (/\/cart\/?$/.test(location.pathname)) {
        const cc = document.querySelector('cart-component[data-av-lines]');
        let rl = null; try { rl = sessionStorage.getItem('av-rl'); } catch (e) {}
        if (cc && Number(cc.dataset.avLines) !== cart.items.length && !rl) { try { sessionStorage.setItem('av-rl', '1'); } catch (e) {} location.reload(); return; }
        try { sessionStorage.removeItem('av-rl'); } catch (e) {}
      }
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    const sid = drawer && drawer.dataset.sectionId;
    const body = { updates };
    if (sid) { body.sections = sid; body.sections_url = location.pathname; }
    const res = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), avSkip: 1 });
    const json = await res.json();
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (drawer && json.sections && json.sections[sid] && typeof drawer.renderCartContents === 'function') {
      drawer.renderCartContents({ sections: json.sections, itemCount: json.item_count });
    }
    if (json.items) setCount(json.items);
  } catch (e) {
    console.error('[AV cadeaux]', e);
  } finally {
    busy = false;
    if (again) { again = false; sync(); }
  }
}

// Bouton « Ajouter » des ventes complémentaires (snippet av-cart-xsell)
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-av-add]');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;
  try {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const drawer = document.querySelector('cart-drawer');
    const sid = drawer && drawer.dataset.sectionId;
    const body = { items: [{ id: Number(btn.dataset.avAdd), quantity: 1 }] };
    if (sid) { body.sections = sid; body.sections_url = location.pathname; }
    const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const json = await res.json();
    if (drawer && json.sections && json.sections[sid] && typeof drawer.renderCartContents === 'function') {
      drawer.renderCartContents({ sections: json.sections });
    }
  } catch (err) {
    console.error('[AV ajout]', err);
  } finally {
    sync();
  }
});

// Boutons « Ajouter au panier » / « Ajouter » de la section gamme de l'accueil (code « av_gamme_v2 », formulaires natifs) :
// ajout sans quitter la page, puis ouverture du panier en tiroir (au lieu de la page /cart). 22/10/2026
document.addEventListener('submit', async (e) => {
  const f = e.target;
  if (!f || !f.matches || !f.matches('.av-tg form')) return;
  e.preventDefault();
  const btn = f.querySelector('button[type="submit"]');
  if (btn) btn.disabled = true;
  try {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const drawer = document.querySelector('cart-drawer');
    const sid = drawer && drawer.dataset.sectionId;
    const fd = new FormData(f);
    const body = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
    if (sid) { body.sections = sid; body.sections_url = location.pathname; }
    const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const json = await res.json();
    if (drawer && json.sections && json.sections[sid] && typeof drawer.renderCartContents === 'function') {
      drawer.renderCartContents({ sections: json.sections, itemCount: 1 });
    }
    if (drawer) { if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('is-open'); }
  } catch (err) {
    console.error('[AV ajout accueil]', err);
    f.submit();
  } finally {
    if (btn) btn.disabled = false;
    sync();
  }
});

document.addEventListener(ThemeEvents.cartUpdated, () => setTimeout(sync, 50));
// 26/10/2026 : contrôle aussi après tout appel au panier (ajout, modification, vidage), y compris sur la page /cart.
(function () {
  if (window.__avFetchWrap) return;
  window.__avFetchWrap = 1;
  const f0 = window.fetch;
  window.fetch = function (input, init) {
    const p = f0.apply(this, arguments);
    try {
      const u = typeof input === 'string' ? input : (input && input.url) || '';
      // Sur la page /cart, chaque modification recharge la page : le contrôle se fait au chargement (évite une double mise à jour).
      if (!(init && init.avSkip) && !/\/cart\/?$/.test(location.pathname) && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(() => setTimeout(sync, 60), () => {});
    } catch (e) {}
    return p;
  };
})();
// 26/10/2026 : contrôle à l'ouverture du tiroir.
let avDrOpen = false;
function avDrawerWatch() {
  const dr = document.querySelector('cart-drawer');
  const o = !!(dr && dr.classList.contains('is-open'));
  if (o && !avDrOpen) sync();
  avDrOpen = o;
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();

// Message « cadeau ajouté » (snippet av-cart-banner) : visible 10 secondes, une seule fois par cadeau débloqué (pas à chaque mise à jour du panier).
const CBN_MS = 10000;
let cbnMem = null;
function cbnGet() { try { return JSON.parse(sessionStorage.getItem('av-cbn')); } catch (e) { return cbnMem; } }
function cbnSet(v) { cbnMem = v; try { if (v) sessionStorage.setItem('av-cbn', JSON.stringify(v)); else sessionStorage.removeItem('av-cbn'); } catch (e) {} }
function cbn() {
  const all = document.querySelectorAll('.av-cbn');
  if (!all.length) { if (document.querySelector('cart-drawer')) cbnSet(null); return; }
  // 26/10/2026 : bandeau du tiroir (quand il est ouvert) ou de la page /cart.
  let el = null;
  all.forEach((x) => { if (el || x.dataset.avDone) return; const d = x.closest('cart-drawer'); if (d && !d.classList.contains('is-open')) return; el = x; });
  if (!el) return;
  el.dataset.avDone = '1';
  let s = cbnGet();
  const now = Date.now();
  if (!s || s.k !== el.dataset.k) { s = { k: el.dataset.k, t: now }; cbnSet(s); }
  const left = CBN_MS - (now - s.t);
  if (left <= 0) return;
  el.classList.add('is-on');
  setTimeout(() => { el.classList.add('is-out'); setTimeout(() => el.classList.remove('is-on'), 400); }, left);
}
// Noms des produits dans le panier : affichage sans « | Atelier Valtis » (le titre Shopify, la fiche, le SEO et GMC ne changent pas).
function avNames() {
  document.querySelectorAll('.cart-drawer__item-name, .cart__item-name').forEach((a) => {
    if (a.dataset.avN) return;
    a.dataset.avN = '1';
    const t = a.textContent;
    const i = t.indexOf(' | ');
    if (i > 0) a.textContent = t.slice(0, i).trim();
  });
}
function avObs() { cbn(); avNames(); avDrawerWatch(); }
new MutationObserver(avObs).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
avObs();

// Accueil mobile : points + « Faites glisser » sous le carrousel « La sélection de l'atelier » (CSS dans snippets/av-cart-banner.liquid). 22/10/2026
function avSelDots() {
  const g = document.querySelector('.av-sel .av-sel__grid');
  if (!g || g.dataset.avDots) return;
  g.dataset.avDots = '1';
  const n = g.children.length;
  const d = document.createElement('div'); d.className = 'av-sel__dots'; d.setAttribute('aria-hidden', 'true');
  for (let i = 0; i < n; i++) { const e = document.createElement('i'); if (i === 0) e.className = 'on'; d.appendChild(e); }
  const p = document.createElement('p'); p.className = 'av-sel__swipe'; p.textContent = '← Faites glisser →';
  g.after(d, p);
  g.addEventListener('scroll', () => {
    const x = g.scrollLeft + g.clientWidth / 2; let b = 0, m = 1e9;
    [...g.children].sort((u, v) => u.offsetLeft - v.offsetLeft).forEach((c, i) => { const o = Math.abs(c.offsetLeft + c.offsetWidth / 2 - x); if (o < m) { m = o; b = i; } });
    d.querySelectorAll('i').forEach((e, i) => e.classList.toggle('on', i === b));
  }, { passive: true });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avSelDots); else avSelDots();
